import { API_URL } from '../../../constants';
import _fetch from '../../_fetch';

export default function blogLogin(options = {}) {
  return function withContext(context) {
    const url = `${API_URL}blog/auth/login`;
    return _fetch(
      url,
      { withAuth: false },
      {
        method: 'POST',
        body: JSON.stringify({ email: options.email, password: options.password }),
        headers: {
          'Accept': 'application/json;charset=utf-8',
          'Content-Type': 'application/json;charset=utf-8'
        }
      }
    )(context);
  };
}
